module.exports = __webpack_public_path__ + "img/train.ca2a631.png";